{
  "names": {
    "Fajr": "Fajr",
    "Dhuhr": "Dohr",
    "Asr": "Asr",
    "Maghrib": "Maghreb",
    "Isha": "Icha"
  },
  "card": {
    "label": "Prochaine prière",
    "labelTomorrow": "Demain · {{prayer}}",
    "inHoursMinutes": "dans {{hours}} h {{minutes}} min",
    "inMinutes": "dans {{minutes}} min",
    "open_aria": "Ouvrir les horaires de prière",
    "pro": "Rhemn Pro",
    "unlock_aria": "Débloquez les horaires de prière avec Rhemn Pro",
    "unavailable": "Horaires de prière indisponibles pour le moment."
  },
  "sheet": {
    "bellOn_aria": "Désactiver le rappel de {{prayer}}",
    "bellOff_aria": "Activer le rappel de {{prayer}}",
    "explainer": "Recevez un rappel discret à chaque prière. Les rappels sont des notifications silencieuses, sans son par défaut.",
    "enableReminders": "Activer les rappels",
    "enableInSettings": "Activez les notifications de Rhemn dans Réglages pour recevoir les rappels de prière.",
    "openSettings": "Ouvrir Réglages"
  },
  "notifications": {
    "body": "C'est l'heure de la prière."
  },
  "focus": {
    "label": "Prière du {{prayer}}",
    "close_aria": "Fermer l'écran de prière",
    "hint": "Appuyez sur Esc ou × pour revenir",
    "phrases": {
      "accepted": "Qu'Allah accepte ta prière",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "Commencez avec intention. Continuez avec la baraka.",
    "prayerApproaches": "Votre prochaine prière approche. Restez ancré dans votre intention.",
    "morningPursue": "Un matin béni pour poursuivre : {{focus}}",
    "dayCloses": "À la tombée du jour, méditez sur : {{focus}}",
    "fulfilled": "Vous avez accompli votre intention aujourd'hui. Alhamdoulillah.",
    "workingTowards": "Aujourd'hui, vous œuvrez vers : {{focus}}",
    "prayerNear": "Votre prochaine prière est proche. Prenez une respiration."
  },
  "widget": {
    "countdown": "dans {{time}}",
    "openToUpdate": "Ouvrez Rhemn pour actualiser",
    "openForVerse": "Ouvrez Rhemn pour le verset du jour"
  }
}
